import { Injectable } from '@angular/core';
import { ApiServiceProvider } from 'app/api-service';

@Injectable()
export class AssociatedNewsService {

  constructor(private apiServiceProvider: ApiServiceProvider) { }

  getNewsArticles(params: any) {
    const payLoad = {
      targetedType: 'riskManagementService',
      method: 'GET',
      servicePath: `events/news`,
      formParams: params ? { ...params } : {},
    };
    return this.apiServiceProvider.post(payLoad);
  }
}
